module.exports = __webpack_public_path__ + "media/site/images/case_studies/ekanban/diagram-f1af2b0056d36b3d6492138bd7914ce0.svg";